import api from '@/fetch/api.js'
import { GetInfo } from '@/fetch/com.js'

let install = (Vue) => {
    // 时间转换主方法
    Vue.prototype.formatDate = (val, fmt = "yyyy-MM-dd hh:mm:ss") => {
        let date = new Date(typeof(val) == 'string' ? (val).replace(/-/g, '/') : val);
        let obj = {
            "M+": date.getMonth() + 1, //月
            "d+": date.getDate(), //日
            "h+": date.getHours(), //时
            "m+": date.getMinutes(), //分
            "s+": date.getSeconds(), //秒
        };
        if (/(y+)/.test(fmt)) { //替换年
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        for (let key in obj) { //替换剩余
            if (new RegExp("(" + key + ")").test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (obj[key]) : (("00" + obj[key]).substr(("" + obj[key]).length)));
            }
        }
        return fmt;
    }
    // 时间戳转换,返回年月日，时分  入参是毫秒或者标准时间格式
    Vue.prototype.formatDateTime = function(inputTime) {
        if (!inputTime) {
            return ""
        } else if (inputTime instanceof Date) {
            inputTime = inputTime.getTime()
        }
        var date = new Date(inputTime);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        var d = date.getDate();
        var h = date.getHours(); //获取小时
        var min = date.getMinutes(); //获取分钟
        if (min < 10) {
            min = "0" + min
        }
        if (h < 10) {
            h = "0" + h
        }
        if (d < 10) {
            d = "0" + d
        }
        m = m < 10 ? ('0' + m) : m;

        return y + '-' + m + '-' + d + " " + h + ":" + min;
    }

    // 时间戳转换,返回年月日，时分秒  入参是毫秒或者标准时间格式
    Vue.prototype.formatDateTimeAll = function(inputTime) {
        if (!inputTime) {
            return ""
        } else if (inputTime instanceof Date) {
            inputTime = inputTime.getTime()
        }
        var date = new Date(inputTime);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        var d = date.getDate();
        var h = date.getHours(); //获取小时
        var min = date.getMinutes(); //获取分钟
        var ss = date.getSeconds();

        if (min < 10) {
            min = "0" + min
        }
        if (h < 10) {
            h = "0" + h
        }
        if (d < 10) {
            d = "0" + d
        }
        m = m < 10 ? ('0' + m) : m;
        ss = ss < 10 ? ('0' + ss) : ss;
        return y + '-' + m + '-' + d + " " + h + ":" + min + ":" + ss;
    }

    // 时间戳转换 返回年月日 入参是毫秒或者标准时间格式
    Vue.prototype.formatDateToDate = function(inputTime) {
        if (!inputTime) {
            return ""
        } else if (inputTime instanceof Date) {
            inputTime = inputTime.getTime()
        }
        var date = new Date(inputTime);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        var d = date.getDate();
        m = m < 10 ? ('0' + m) : m;
        d = d < 10 ? ('0' + d) : d;
        return y + '-' + m + '-' + d;
    }

    //图片校验，基础校验。类型，大小，可自己传入校验函数，完善校验
    Vue.prototype.$checkImg = function(file, checkCallBack) {
        if (typeof checkCallBack == 'function') {
            checkCallBack()
        }
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isBMP = file.type === 'image/bmp';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG && !isPNG && !isBMP) {
            this.$notify.error('请正确上传图片!');
        }
        if (!isLt2M) {
            this.$notify.error('上传头像图片大小不能超过 2MB!');
        }
        return (isJPG || isPNG || isBMP) && isLt2M;
    }

    //文件超出个数限制的提示
    Vue.prototype.$handleExceed = function(files, fileList) {
        this.$message.warning(`当前限制选择${fileList.length}个文件`);
    }

     /**
     * 获取文本的字节长度，一个汉字相当于三个字节长度，英文相当于1个字节
     * @param {s} 需要查询的字符串长度 
     * @param {boo} 默认为 true, 返回字符长度；false：返回字符串的个数； 
     */
    Vue.prototype.$getStrLen = function(s, bool = true){
        if(!bool) return s.length;
        let l = 0;
        let a = s.split("");
        for (let i = 0; i < a.length; i++) {
            if (a[i].charCodeAt(0) < 299) {
                l++;
            } else {
                l += 3;
            }
        }
        return l;
    }

    //获取文件列表列表,并且转换为json.string
    Vue.prototype.$getFileList = function(file) {
        for (let i in file) {
            delete file[i].status
            delete file[i].uid
        }
        return JSON.stringify(file)
    }

    //公共弹出
    Vue.prototype.$showAlert = function(content, type = "success", title) {
        const titleValue = {
            "success": "成功",
            "warning": "警告",
            "info": "消息",
            "error": "错误"
        }
        title = title || titleValue[type]
        this.$notify({
            title: title,
            message: content,
            type: type
        });
    }

    //公共，获取分页参数，接收返回数据
    Vue.prototype.$getPageConfig = function(response, myConfig) {
        if (response.data && response.data.data.length > 0) {
            const pageConfig = {
                pageSizes: [10, 20],
                layout: 'slot,sizes, prev, pager, next, jumper',
                pageNumber: response.data.index,
                pageSize: response.data.size,
                total: response.data.totalRecord
            }
            if (myConfig) {
                return Object.assign(pageConfig, myConfig)
            } else {
                return pageConfig
            }
        } else {
            return {
                pageNumber: 1,
                pageSize: 10,
                total: 0
            }
        }
    }
    //获取某个分类下的所有常量
    Vue.prototype.getAllConstant = function(type) {
        function unescapeHTML(a) {
            a = "" + a;
            return a.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&apos;/g, "'");
        }

        let allSystemConstant = {}
        return new Promise((resolve, reject) => {
            api.http({ url: "/system_constants/list_show", params: { constantsType: type } }).then(res => {
                if (res.data) {
                    res.data.forEach(row => {
                        if (allSystemConstant[row.constantsType]) {
                            allSystemConstant[row.constantsType].push({
                                key: unescapeHTML(row.constantsValue),
                                value: unescapeHTML(row.constantsValueDesc)
                            })
                        } else {
                            allSystemConstant[row.constantsType] = []
                            allSystemConstant[row.constantsType].push({
                                key: unescapeHTML(row.constantsValue),
                                value: unescapeHTML(row.constantsValueDesc)
                            })
                        }
                    })
                    resolve(allSystemConstant)
                } else {
                    resolve(allSystemConstant)
                }
            }).catch(e => {
                reject(e)
            })
        })
    }
    //校验相关方法
    Vue.prototype.$checkNumber = function(rule, value, callback) {
        const patt = /^([1-9]\d*|[1]{1,1})$/;
        if (!patt.test(value)) {
            callback(new Error(rule.message || '请输入一个大于或等于1的整数!'));
        } else {
            callback()
        }
    }
    //不小于0的数字，小数或者整数，可以为0
    Vue.prototype.$checkPoint0 = function(rule, value, callback) {
        const reg = /^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$/
        if (reg.test(value)) {
            callback()
        } else {
            callback(new Error(rule.message || '请输入一个不小于0的数字!'));
        }
    }
    //不小于0的数字，小数或者整数
    Vue.prototype.$checkPoint = function(rule, value, callback) {
        const reg = /^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$/
        if (reg.test(value)) {
            callback()
        } else {
            if (value == 0) {
                callback()
            } else {
                callback(new Error(rule.message || '请输入一个不小于0的数字!'));
            }
        }
    }

    //正整数
    Vue.prototype.$positiveInte = function(rule, value, callback) {
        const reg = /^[1-9]\d*$/
        if (reg.test(value)) {
            if ((value + '').length < 9) {
                callback()
            } else {
                callback(new Error('请输入0---10位数字!'));
            }
        } else {
            callback(new Error(rule.message || '请输入一个正整数!'));
        }
    }
    //通用工作流
    //获取流程参数
    Vue.prototype.$getProcessParam = function(params) {
        return new Promise((resolve, reject) => {
            api.http({ url: "/commonProcess/getProcessStartActinstInfo", params: params }).then(res => {
                if (res.data && res.data.paramList) {
                    resolve(res.data.paramList)
                } else {
                    resolve("查询出错")
                }
            }).catch(e => {
                reject(e)
            })
        })
    }
    //流程开始
    Vue.prototype.$processStart = function(params, callBack, errorCB) {
        api.http({ url: "/commonProcess/startProcess", params: params, type: "post" }).then(res => {
            if (res.code == 200) {
                this.$showAlert(res.message)
                callBack()
            } else {
                if (errorCB) {
                    errorCB(res)
                } else {
                    this.$showAlert(res.message, 'error')
                }
            }
        }).catch(e => {
            errorCB && errorCB(e)
        })
    }
    /**
     * 删除element附件里面的多余字段
     * @param fileList
     * @returns {*|Array}
     */
    Vue.prototype.$dealFile = function(fileList) {
        let arr = fileList || []
        arr.forEach(row =>{
            delete row.status
            delete row.uid
        })
        return arr
    }

    // 判断是否是function
    Vue.prototype.$isFun = function(fn) {
        return Object.prototype.toString.call(fn).slice(8, -1).toLowerCase() == 'function';
    }

    //更新项目及的配置，获取的数据在vuex里面，这里登录的时候 会调用一次，之后更新了配置请自己主动调用
    Vue.prototype.getProjectConfig = function(callBack) {
        const getInitValue = function(row) {
            if (row.styleType === 'radio' || row.styleType === 'select') {
                const itemArr = row.initValue.split(",")
                const itemMap = {}
                let temp = []
                itemArr.forEach(item => {
                    temp = item.split("_")
                    itemMap[temp[0] + ''] = temp[1]
                })
                return itemMap
            } else {
                return row.initValue
            }
        }
        const projectId = GetInfo("projectId")
        api.http({ url: "/system/SysGeneralConfig/list", params: { projectId: projectId } }).then(res => {
            callBack && callBack()
            if (res.code === 200) {
                let tempMap = {}
                res.data.forEach(row => {
                    row.initValue = getInitValue(row)
                    tempMap[row.attributeCode] = {
                        attributeName: row.attributeName,
                        attributeValue: row.attributeValue,
                        initValue: row.initValue,
                        id: row.id,
                        subList: row.subList
                    }
                })
                this.$store.commit('PROJECT_CONFIG', tempMap)
            }
        }).catch(e => {
            
        })
    }
};

export default {
    methods: [install],
}
